<cds-modal size="sm" [open]="editDealModalOpen">
	<cds-modal-header>
		<h3 cdsModalHeaderHeading>
			Edit {{dealName}}
		</h3>
	</cds-modal-header>
	<section cdsModalContent #cdsModalContent [hasForm]="true">
<!--		<cds-text-label style="margin: 8px 0" [invalid]="dealNameInvalid" [invalidText]="dealNameInvalidText">-->
<!--			Fund Name-->
<!--			<input (keyup.enter)="onSaveDealClick()" size="md" [(ngModel)]="dealName" (keyup)="onKeyUpDealName($event)" cdsText type="text" class="input-field" placeholder="New Deal">-->
<!--		</cds-text-label>-->

<!--		<cds-text-label size="md" style="margin: 8px 0" [invalid]="fundNameInvalid" [invalidText]="fundNameInvalidText">-->
<!--			Fund Name-->
<!--			<input [(ngModel)]="fundName" (keyup)="onKeyUpFundName($event)" cdsText type="text" class="input-field" placeholder="New Fund">-->
<!--		</cds-text-label>-->

		<cds-select
			size="md"
			[label]="'Fund Type'"
			[(ngModel)]="fundType"
			[invalid]="fundInvalid"
			invalidText="Select a fund type."
			(change)="onSelectFundType($event)"
		>
			<option *ngFor="let fundType of fundTypes.slice(0, 2)" [value]="fundType">{{fundType}}</option>
			<option *ngFor="let fundType of fundTypes.slice(2)" disabled="disabled" [value]="fundType">{{fundType}}</option>
		</cds-select>

		<div #datePicker1 style="margin: 8px 0">
			<cds-date-picker
				label="Received Date"
				[value]="receivedDateObject"
				[invalid]="receivedDateInvalid"
				invalidText="Select a received date."
				(valueChange)="onSelectReceivedDate($event)"
			></cds-date-picker>
		</div>

		<div #datePicker2 style="margin: 8px 0">
			<cds-date-picker
				[label]="'Deadline Date'"
				[value]="deadlineDateObject"
				[invalid]="deadlineDateInvalid"
				invalidText="Select a deadline date."
				(valueChange)="onSelectDeadlineDate($event)"
			></cds-date-picker>
		</div>

		<div #datePicker3 style="margin: 8px 0">
			<cds-date-picker
				label="Pricing Reference Date"
				[value]="pricingReferenceDateObject"
				[invalid]="pricingReferenceDateInvalid"
				invalidText="Select a pricing reference date."
				(valueChange)="onSelectPricingReferenceDate($event)"
			></cds-date-picker>
		</div>

	</section>
	<cds-modal-footer>
		<button class="cds--btn cds--btn--secondary" (click)="closeModal()">
			Cancel
		</button>
		<button class="cds--btn cds--btn--primary" (click)="onSaveDealClick()">
			Save
		</button>
	</cds-modal-footer>
</cds-modal>
